// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"seo-blocks_breadcrumbs__pNPNb","carousel":"seo-blocks_carousel__cPlL9"};